import type { BalanceApi } from "../../api/BalanceApi";
import type { BalanceFetchOptions } from "../../generated/dto/BalanceFetchOptions";
import type { BalanceLookupCooldownFetchOptions } from "../../generated/dto/BalanceLookupCooldownFetchOptions";
import type { BalanceLookupCooldownStaff } from "../../generated/dto/BalanceLookupCooldownStaff";
import type { BalanceMember } from "../../generated/dto/BalanceMember";
import type { BalanceMemberPage } from "../../generated/dto/BalanceMemberPage";
import type { BalanceSaveRequest } from "../../generated/dto/BalanceSaveRequest";
import type { BalanceSearchOptions } from "../../generated/dto/BalanceSearchOptions";
import type { BalanceSearchParams } from "../../generated/dto/BalanceSearchParams";
import type { BalanceStaff } from "../../generated/dto/BalanceStaff";
import type { BalanceStaffPage } from "../../generated/dto/BalanceStaffPage";
import type { BalanceStaffSearchResult } from "../../generated/dto/BalanceStaffSearchResult";
import type { BalanceTransactionFetchOptions } from "../../generated/dto/BalanceTransactionFetchOptions";
import type { BalanceTransactionStaff } from "../../generated/dto/BalanceTransactionStaff";
import type { PersonBalanceFetchOptions } from "../../generated/dto/PersonBalanceFetchOptions";
import type { PersonBalanceStaff } from "../../generated/dto/PersonBalanceStaff";
import type { PersonFetchOptions } from "../../generated/dto/PersonFetchOptions";
import type { PersonStaff } from "../../generated/dto/PersonStaff";
import type { PaginationResult } from "../../generated/dto/PaginationResult";

export class BalanceFrontendService {
  constructor(private readonly api: BalanceApi) {}
  async getBalanceStaff(id: number, options?: BalanceFetchOptions): Promise<BalanceStaff> {
    return this.api.getBalanceStaff(id, options)
  }
  async getPersonBalanceStaff(id: number, options?: PersonBalanceFetchOptions): Promise<PersonBalanceStaff> {
    return this.api.getPersonBalanceStaff(id, options)
  }
  async getBalanceLookupCooldownStaff(id: number, options?: BalanceLookupCooldownFetchOptions): Promise<BalanceLookupCooldownStaff> {
    return this.api.getBalanceLookupCooldownStaff(id, options)
  }
  async searchBalanceStaff(params: BalanceSearchParams, page: number, perPage: number): Promise<PaginationResult<BalanceStaffSearchResult>> {
    return this.api.searchBalanceStaff(params, page, perPage)
  }
  async searchBalanceStaffFull(params: BalanceSearchParams, page: number, perPage: number, options?: BalanceFetchOptions): Promise<PaginationResult<BalanceStaff>> {
    return this.api.searchBalanceStaffFull(params, page, perPage, options)
  }
  async getBalanceStaffBalanceOwner(id: number, options?: PersonFetchOptions): Promise<PersonStaff | null> {
    return this.api.getBalanceStaffBalanceOwner(id, options)
  }
  async getBalanceStaffPersonBalances(id: number, options?: PersonBalanceFetchOptions): Promise<Array<PersonBalanceStaff>> {
    return this.api.getBalanceStaffPersonBalances(id, options)
  }
  async getBalanceStaffTransactions(id: number, options?: BalanceTransactionFetchOptions): Promise<Array<BalanceTransactionStaff>> {
    return this.api.getBalanceStaffTransactions(id, options)
  }
  async getPersonBalanceStaffBalanceId(id: number, options?: BalanceFetchOptions): Promise<BalanceStaff> {
    return this.api.getPersonBalanceStaffBalanceId(id, options)
  }
  async getPersonBalanceStaffPersonId(id: number, options?: PersonFetchOptions): Promise<PersonStaff> {
    return this.api.getPersonBalanceStaffPersonId(id, options)
  }
  async getBalanceLookupCooldownStaffPersonId(id: number, options?: PersonFetchOptions): Promise<PersonStaff> {
    return this.api.getBalanceLookupCooldownStaffPersonId(id, options)
  }
  async getBalanceLookupCooldownStaffBalanceMatch(id: number, options?: BalanceFetchOptions): Promise<BalanceStaff | null> {
    return this.api.getBalanceLookupCooldownStaffBalanceMatch(id, options)
  }
  async balancesStaff(options: BalanceSearchOptions): Promise<BalanceStaffPage> {
    return this.api.balancesStaff(options)
  }
  async findBalanceByNumStaff(number: string): Promise<BalanceStaff> {
    return this.api.findBalanceByNumStaff(number)
  }
  async findBalanceByNumMember(number: string): Promise<BalanceMember> {
    return this.api.findBalanceByNumMember(number)
  }
  async memberBalancesMember(options: BalanceSearchOptions): Promise<BalanceMemberPage> {
    return this.api.memberBalancesMember(options)
  }
  async saveBalanceStaff(request: BalanceSaveRequest): Promise<BalanceStaff> {
    return this.api.saveBalanceStaff(request)
  }
}
